import ContentLoader from "react-content-loader";
import React from "react";

const ListLoader = () => (
  <ContentLoader height={500} primaryColor="#f3f3f3" secondaryColor="#ecebeb" speed={2} width={900}>
    <rect height="10" rx="3" ry="3" width="100" x="0" y="25" />
    <rect height="10" rx="3" ry="3" width="100" x="225" y="25" />
    <rect height="10" rx="3" ry="3" width="100" x="525" y="25" />
    <rect height="10" rx="3" ry="3" width="100" x="750" y="25" />
    <rect height="10" rx="3" ry="3" width="30" x="875" y="25" />
    <rect height="10" rx="3" ry="3" width="100" x="0" y="90" />
    <rect height="10" rx="3" ry="3" width="100" x="225" y="90" />
    <rect height="10" rx="3" ry="3" width="100" x="525" y="90" />
    <rect height="10" rx="3" ry="3" width="100" x="750" y="90" />
    <rect height="10" rx="3" ry="3" width="30" x="875" y="90" />
    <rect height="10" rx="3" ry="3" width="100" x="0" y="145" />
    <rect height="10" rx="3" ry="3" width="100" x="225" y="145" />
    <rect height="10" rx="3" ry="3" width="100" x="525" y="145" />
    <rect height="10" rx="3" ry="3" width="100" x="750" y="145" />
    <rect height="10" rx="3" ry="3" width="30" x="875" y="145" />
    <rect height="10" rx="3" ry="3" width="100" x="0" y="200" />
    <rect height="10" rx="3" ry="3" width="100" x="225" y="200" />
    <rect height="10" rx="3" ry="3" width="100" x="525" y="200" />
    <rect height="10" rx="3" ry="3" width="100" x="750" y="200" />
    <rect height="10" rx="3" ry="3" width="30" x="875" y="200" />
  </ContentLoader>
);

export default ListLoader;
